<template>
    <input 
        type="file"
        @change="readFile"
        @click="$event.target.value=''"
        ref="excelUpload" 
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        <!-- 엑셀파일에 대한 content-type -->
</template>

<script setup>
import * as XLSX from 'xlsx';
import {ref} from 'vue'
import common from '@/js/common';

const excelUpload = ref()
const emits = defineEmits(['return'])

const props = defineProps({
    headerKeys : {
        type : Array,
        default : []
    },
    dataFormat :{
        type : Boolean,
        default : true
    }
})

const selectUploadFile = () => {
    excelUpload.value.click()
}

const readFile = (event) =>{
    let returnData = new Object()
    returnData.file = event.target.files[0];
    const file = event.target.files[0];

    let reader = new FileReader();
    let tmpResult = [];
    reader.onload = (e) => {
        let data = reader.result;
        let workBook = XLSX.read(data, { type: 'binary', cellDates: true });
        workBook.SheetNames.forEach(sheetName => {
            if(props.headerKeys.length > 0){
                let asciiNum = 65
                for(let i=0; i<props.headerKeys.length; i++){

                    let firstLetterIndex = Math.floor(i / 26); // 앞자리 계산
                    let secondLetterIndex = i % 26; // 뒷자리 계산

                    // 첫 번째와 두 번째 글자를 조합하여 capital 생성
                    let capital = (firstLetterIndex > 0 
                        ? String.fromCharCode(asciiNum + firstLetterIndex - 1) 
                        : '') + String.fromCharCode(asciiNum + secondLetterIndex) + '1';
                    if(workBook.Sheets[sheetName][capital]?.w && workBook.Sheets[sheetName][capital]?.w != null && workBook.Sheets[sheetName][capital]?.w != undefined){
                        workBook.Sheets[sheetName][capital].w = props.headerKeys[i]

                    }
                }
            }
            const roa = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
            tmpResult.push(roa)
        });
        //emit을 통하여 부모창에게 읽은 엑셀파일을 전달한다.
        returnData.sheets = tmpResult
        emits('return',returnData) 
    };
    reader.readAsBinaryString(file);
}

const excelOptyDownload = (header, dataListBySheet, headerProps) => {

    const createTable = (header, dataList, headProps,index,sheetName) => {
        
        const table = document.createElement('table');
        const headerSet = Array.isArray(header) ? header : [header]; 
        
        const thead = document.createElement('thead');

        const row = [...headerSet[index]] //이게 반복이 안된다고 하는데 ? 
        
            const tr = document.createElement('tr');
            for (const h of row) {            
                const rowspan = h.rowspan || '1';
                const colspan = h.colspan || '1';
                const th = document.createElement('th');
                th.setAttribute('rowspan', rowspan);
                th.setAttribute('colspan', colspan);
                th.innerText = h.header;
                tr.appendChild(th);
            }
            thead.appendChild(tr);
        
        table.appendChild(thead); 
        const tbody = document.createElement('tbody');
        for (const row of dataList) {
            const tr = document.createElement('tr');
            for (const cellKey of headProps[sheetName]) {
                const td = document.createElement('td');           
                td.innerText = row[cellKey] == undefined ? '' : row[cellKey];
                tr.appendChild(td);
            }
            tbody.appendChild(tr);
        }
        table.appendChild(tbody);
        return table;
        
    };

    const wb = XLSX.utils.book_new();
    let i = 0;
    for (const  sheetName in dataListBySheet) {
        const dataList = dataListBySheet[sheetName]; 
        const tableInstance = createTable(header, dataList, headerProps, i,sheetName); 
        const config = { raw: true, type: 'string' };
        const ws = XLSX.utils.table_to_sheet(tableInstance, config);
        Object.keys(ws).filter((key1)=>{
            if(typeof ws[key1] === 'object'){
                return true
            }
        }).forEach((key)=>{
            if(props.dataFormat) {
                //숫자형은 cell type 숫자형으로 수정
                /**
                    b	: Boolean
                    e	: Error
                    n	: Number
                    d	: Date
                    s	: Text
                    z	: Stub
                */
                if(ws[key]?.v && typeof ws[key] === 'object'){
                    let type = 's'

                    if(!isNaN(Number(ws[key]['v']))){
                        ws[key]['v'] = Number(ws[key]['v']); // 명시적으로 숫자로 변환
                        type = 'n'; // 타입 설정
                        if (Number.isInteger(ws[key]['v'])) {
                           // ws[key]['z'] = '#,##0'; // 정수 형식 설정
                        } else {
                            type = 'g'; // 소수인 경우 일반 형식
                        }
                        ws[key]['t'] = type
                    }else if(ws[key]['v'].substring(ws[key]['v'].length-1) === '%'){
                        const cellData = ws[key]['v'].substring(0,ws[key]['v'].length-1).replaceAll('-','')
                        if(common.checkNumber(cellData) || common.checkFloat(cellData)){
                            //문자열중에 퍼센트(%) 포멧팅인 경우 type 숫자
                            type = 'n'
                            if(props.dataFormat) ws[key]['z'] = "0.0%"
                            ws[key]['v'] = (Number(ws[key]['v'].substring(0,ws[key]['v'].length-1)) / 100).toFixed(4)
                        }
                        ws[key]['t'] = type
                    }else if(common.checkDateForm(ws[key]['v'])){ 
                        //날짜형식 시분초 제외하고 표출 
                            
                            
                            // 날짜 문자열을 Date 객체로 변환
                            // const dateValue = new Date(ws[key]['v']);
                            const [year, month, day] = ws[key]['v'].split("-").map(Number);
                            const newDate = new Date(Date.UTC(year, month - 1, day,0,0,0)); // 시간대를 UTC로 설정
                            
                            // xlsx 라이브러리에 맞게 날짜를 Excel 날짜 형식으로 변환
                            ws[key]['v'] = (newDate - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000); 
                            ws[key]['t'] = 'n';
                            
                    }
                    
                }
            }else{
                ws[key]['t'] = 's'
            }

        })
        autofitColumns(ws)
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        i++;
    }

    XLSX.writeFile(wb, '영업기회 템플릿.xlsx');
};


function getEndingDigit(inputString) {
    const regex = /\d+$/;

    if (regex.test(inputString)) {
        const match = inputString.match(regex);
        return match[0].replace(/\D/g, '');
    }

    return null;
}

function autofitColumns(worksheet) {
    let objectMaxLength = [];

    const [startLetter, endLetter] = worksheet['!ref']?.replace(/\d/, '').split(':')
    const ranges = []

    let startIdx = startLetter.charCodeAt(0)
    let endIdx = 0;

    const regex = /^[A-Z]$/;
    [...endLetter].forEach((char,index)=>{
        if(regex.test(char)){
            endIdx = char.charCodeAt(0) + (index * 26)
        }
    })

    for(let i =startIdx; i<(endIdx + 1); i++){
        ranges.push(i)
    }

    ranges.forEach((c) => {
        const cellHeader = String.fromCharCode(c)

        let maxCellLengthForWholeColumn = Array.from(
        { length: getEndingDigit(worksheet['!ref']) },
        (_, i) => i
        ).reduce((acc, i) => {
        const cell = worksheet[`${cellHeader}${i + 1}`]

        // empty cell
        if (!cell) return acc
        const charLength = typeof cell.v === 'number' ? cell.v.toString().length+3 : cell.v.length + 7  

        return acc > charLength ? acc : charLength
        }, 0)
        if(maxCellLengthForWholeColumn === 0) maxCellLengthForWholeColumn = 10
        objectMaxLength.push({ wch: maxCellLengthForWholeColumn })
    })
    worksheet['!cols'] = objectMaxLength
}

defineExpose({
    excelOptyDownload,
    selectUploadFile
})
</script>